module.exports = __webpack_public_path__ + "dummy-44b947b63cf0600f3b84159349aeeab1.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/tmp/layers/base_layer/dummy.png
// module id = 271
// module chunks = 0